import { gql } from '@apollo/client';

const GET_ORG_UNITS_AGGREGATE_REPORT = gql`
  query GetMddapOrgUnitAggregateReport($id: Int!) {
    aggregateOrgUnitReport(id: $id) {
      Id
      Name
      Fei
      Address1
      Address2
      City
      State
      ZipCode
      EnrollmentDate
      AppraisalOrgUnits {
        Id
        Appraisal {
          Id
          Name
          ConductAppraisalEndDate
          AppraisalTeamLead {
            Id
            Individual {
              Id
              Name
            }
          }
          AppraisalTeamMembers {
            Individual {
              Id
              Name
            }
            Type
          }
          AppraisalOrgUnits {
            Id
            Name
            AppraisalOrgUnitProjects {
              Id
              Name
              Description
            }
            MddapOrgUnitId
            IsUserHasAccessOrgUnit
          }
        }
        AggregatePercentage
        AppraisalOrgUnitTargetPracticeAreas {
          Id
          AggregatePercentage
          PracticeArea {
            Id
            Name
            Acronym
          }
          PracticeGroup {
            Id
            Level
          }
        }
        AppraisalProgramYear
        ReappraisalRationaleDocument {
          Id
          FileName
          CheckpointId
        }
      }
      MddapOrganization {
        Id
        Name
      }
      MddapOfficeOfHealthTechnologies {
        Id
        OfficeOfHealthTechnology {
          Id
          Value
        }
      }
    }
    isPercentageVisible(orgUnitId: $id, reportName: "aggregate-appraisal")
  }
`;

export default GET_ORG_UNITS_AGGREGATE_REPORT;
